module.exports = "<igo-layer-list\r\n  igoLayerListBinding\r\n  [excludeBaseLayers]=\"excludeBaseLayers\"\r\n  [ogcFilterInLayerItem]=\"ogcFilterInLayerItem\"\r\n  [toggleLegendOnVisibilityChange]=\"toggleLegendOnVisibilityChange\">\r\n</igo-layer-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/map-details-tool/map-details-tool.component.html
// module id = 1144
// module chunks = 0